import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  constructor(private titleService: Title, private translate: TranslateService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.translate.use(this.translate.currentLang);
    } else {
      this.translate.use('it');
    }
    this.translate.get('breadcrumb.about').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('breadcrumb.about').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
    });
  }
}
